import { createContext } from 'react'

export const FieldLockModeContext = createContext<boolean>(false)
